import { ENV } from '@/constants/config';
import { 
// eslint-disable-next-line no-restricted-imports
safeLog as safeLog_, 
// eslint-disable-next-line no-restricted-imports
safeTable as safeTable_, 
// eslint-disable-next-line no-restricted-imports
safeWarn as safeWarn_ } from '@winelidays/wld-tsx-2/utils';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const safeLog = (...args) => safeLog_(ENV, ...args);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const safeWarn = (...args) => safeWarn_(ENV, ...args);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const safeTable = (...args) => safeTable_(ENV, ...args);
export default safeLog;
